import * as React from 'react';

import ToDoRow from './ToDoRow';
import { HardcodedToDoExplainer } from 'kb-shared';

type Props = {
  explainer: HardcodedToDoExplainer;
  isGyn?: boolean;
  isMale?: boolean;
};

const IntakeForm = (props: Props) => {
  const {
    isGyn,
    isMale,
    explainer: { title, body }
  } = props;

  let queryString = '';
  if (isGyn) {
    queryString = '?appointment=gyn';
  } else if (isMale) {
    queryString = '?male=true';
  }

  return (
    <ToDoRow
      title={title}
      description={body}
      buttonText="Complete form"
      // @ts-ignore
      onClick={() => (window.location = `/patient-intake${queryString}`)}
    />
  );
};

export default IntakeForm;
